import React, { useState } from 'react';
import { CheckCircle2, ShieldCheck, Phone, Tag } from 'lucide-react';
const PHONE = '586-203-3701';
export function QuoteForm() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    zip: '',
    service: 'Full Shingle Roof Replacement',
    timeline: 'ASAP — I have damage or a leak',
    notes: ''
  });
  const update = (k: string, v: string) => setForm(f => ({
    ...f,
    [k]: v
  }));
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="quote-form" className="bg-[#1a2332] py-20 sm:py-24 relative overflow-hidden" data-id="element-133">
      <div className="absolute inset-0 shingle-pattern opacity-10" data-id="element-134" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="grid lg:grid-cols-5 gap-10 items-start" data-id="element-136">
          {/* Left column: pitch */}
          <div className="lg:col-span-2 text-white" data-id="element-137">
            <div className="inline-flex items-center gap-2 bg-[#2DB8E0]/20 border border-[#2DB8E0]/40 rounded-full px-4 py-1.5 mb-5" data-id="element-138">
              <Tag className="w-4 h-4 text-[#2DB8E0]" data-id="element-139" />
              <span className="text-[#2DB8E0] font-bold text-xs uppercase tracking-wider" data-id="element-140">
                $500 Off — Limited Time
              </span>
            </div>
            <h2 className="font-display italic text-4xl sm:text-5xl leading-tight mb-5" data-id="element-141">
              Get Your Free Roof Quote Today
            </h2>
            <p className="text-white/80 leading-relaxed mb-8" data-id="element-142">
              Fill out the form and a Moceri professional will reach out within
              one business day to schedule your free, no-obligation inspection.
              Mention this page to lock in your
              <span className="text-[#2DB8E0] font-bold" data-id="element-143"> $500 discount</span>.
            </p>

            <ul className="space-y-3 mb-8" data-id="element-144">
              {['Free on-site inspection', 'Upfront, written pricing — no surprises', 'Premium shingles built for Michigan weather', 'Financing available — ask about options'].map(i => <li key={i} className="flex items-start gap-3" data-id="element-145">
                  <CheckCircle2 className="w-5 h-5 text-[#2DB8E0] flex-shrink-0 mt-0.5" data-id="element-146" />
                  <span className="text-white/90" data-id="element-147">{i}</span>
                </li>)}
            </ul>

            <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center gap-3 text-white hover:text-[#2DB8E0] font-bold transition-colors" data-id="element-148">
              <Phone className="w-5 h-5 text-[#2DB8E0]" data-id="element-149" />
              Prefer to call? {PHONE}
            </a>
          </div>

          {/* Right column: form card */}
          <div className="lg:col-span-3" data-id="element-150">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 relative overflow-hidden" data-id="element-151">
              <div className="absolute top-0 left-0 w-full h-2 bg-[#2DB8E0]" data-id="element-152" />

              {submitted ? <div className="text-center py-10" data-id="element-153">
                  <div className="w-16 h-16 bg-[#2DB8E0]/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-154">
                    <CheckCircle2 className="w-9 h-9 text-[#2DB8E0]" data-id="element-155" />
                  </div>
                  <h3 className="font-display italic text-3xl text-[#1a2332] mb-3" data-id="element-156">
                    Thanks, {form.name.split(' ')[0] || 'friend'}!
                  </h3>
                  <p className="text-slate-600 mb-6 max-w-md mx-auto" data-id="element-157">
                    We've received your request and a Moceri team member will
                    reach out within one business day. Need it sooner?
                  </p>
                  <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center gap-2 bg-[#2DB8E0] hover:bg-[#1a9cc4] text-white font-bold px-6 py-3 rounded-full transition-colors" data-id="element-158">
                    <Phone className="w-5 h-5" data-id="element-159" /> Call {PHONE}
                  </a>
                </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-160">
                  <h3 className="font-display italic text-3xl text-[#1a2332] mb-1" data-id="element-161">
                    Claim Your $500 Off
                  </h3>
                  <p className="text-sm text-slate-500 mb-4" data-id="element-162">
                    No spam. No obligation. Response within 1 business day.
                  </p>

                  <div data-id="element-163">
                    <label htmlFor="name" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-164">
                      Full Name <span className="text-[#2DB8E0]" data-id="element-165">*</span>
                    </label>
                    <input id="name" type="text" required value={form.name} onChange={e => update('name', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all" placeholder="John Smith" data-id="element-166" />
                  </div>

                  <div className="grid sm:grid-cols-2 gap-4" data-id="element-167">
                    <div data-id="element-168">
                      <label htmlFor="phone" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-169">
                        Phone <span className="text-[#2DB8E0]" data-id="element-170">*</span>
                      </label>
                      <input id="phone" type="tel" required value={form.phone} onChange={e => update('phone', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all" placeholder="(586) 555-0100" data-id="element-171" />
                    </div>
                    <div data-id="element-172">
                      <label htmlFor="zip" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-173">
                        ZIP Code <span className="text-[#2DB8E0]" data-id="element-174">*</span>
                      </label>
                      <input id="zip" type="text" required value={form.zip} onChange={e => update('zip', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all" placeholder="48081" data-id="element-175" />
                    </div>
                  </div>

                  <div data-id="element-176">
                    <label htmlFor="email" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-177">
                      Email <span className="text-[#2DB8E0]" data-id="element-178">*</span>
                    </label>
                    <input id="email" type="email" required value={form.email} onChange={e => update('email', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all" placeholder="john@example.com" data-id="element-179" />
                  </div>

                  <div className="grid sm:grid-cols-2 gap-4" data-id="element-180">
                    <div data-id="element-181">
                      <label htmlFor="service" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-182">
                        Service Needed
                      </label>
                      <select id="service" value={form.service} onChange={e => update('service', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all bg-white" data-id="element-183">
                        <option data-id="element-184">Full Shingle Roof Replacement</option>
                        <option data-id="element-185">Asphalt Shingle Roof</option>
                        <option data-id="element-186">Storm/Hail Damage Inspection</option>
                        <option data-id="element-187">Not sure — need advice</option>
                      </select>
                    </div>
                    <div data-id="element-188">
                      <label htmlFor="timeline" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-189">
                        Timeline
                      </label>
                      <select id="timeline" value={form.timeline} onChange={e => update('timeline', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all bg-white" data-id="element-190">
                        <option data-id="element-191">ASAP — I have damage or a leak</option>
                        <option data-id="element-192">Within 1 month</option>
                        <option data-id="element-193">1–3 months</option>
                        <option data-id="element-194">Just getting quotes</option>
                      </select>
                    </div>
                  </div>

                  <div data-id="element-195">
                    <label htmlFor="notes" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-196">
                      Tell us about your project{' '}
                      <span className="text-slate-400 font-normal" data-id="element-197">
                        (optional)
                      </span>
                    </label>
                    <textarea id="notes" rows={3} value={form.notes} onChange={e => update('notes', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all resize-none" placeholder="e.g. Two-story colonial, missing shingles after last storm…" data-id="element-198" />
                  </div>

                  <button type="submit" className="w-full bg-[#2DB8E0] hover:bg-[#1a9cc4] text-white font-bold text-lg py-4 rounded-full transition-all shadow-md hover:shadow-lg mt-2" data-id="element-199">
                    Get My Free Quote + $500 Off
                  </button>

                  <p className="text-xs text-center text-slate-500 flex items-center justify-center gap-1.5" data-id="element-200">
                    <ShieldCheck className="w-3.5 h-3.5" data-id="element-201" /> Your information is
                    secure and private.
                  </p>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}